import { render, staticRenderFns } from "./TaskPlanningDetail.vue?vue&type=template&id=680645e2&"
import script from "./TaskPlanningDetail.vue?vue&type=script&lang=js&"
export * from "./TaskPlanningDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports